import { render } from "./DocumentTable.vue?vue&type=template&id=6f66085a"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"

import "./DocumentTable.vue?vue&type=style&index=0&id=6f66085a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__